import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var LockIcon = function (_a) {
    var size = _a.size, className = _a.className;
    return (_jsxs("svg", { className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("rect", { x: "3", y: "11", width: "18", height: "11", rx: "2", ry: "2" }), _jsx("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })] }));
};
